module.exports = __webpack_public_path__ + "assets/img/1c5d30a15839a7269b53ddf178bdd861.png";